export default __webpack_public_path__ + "static/media/A4 large 1.2eac6fb8.jpg";